import { ShareSummaryEntry } from '@/common/model/media/shareOfVoice'

import { PIE_CHART_COLORS } from '@/components/view/atoms/chart/chartColors'
import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import ItemAlign from '@/components/view/layouts/item/ItemAlign'

interface Props {
  shareSummary: Record<string, ShareSummaryEntry>
}

const METRICS: { label: string; key: keyof ShareSummaryEntry; suffix?: string }[] = [
  { label: '言及回数', key: 'mention_count' },
  { label: 'シェア率', key: 'share_pct', suffix: '%' },
  { label: '平均順位', key: 'avg_position' },
  { label: 'TOP3率', key: 'top3_rate', suffix: '%' }
]

// ブランド別の指標テーブル（色見本はドーナツグラフの系列色と対応させる）
const ShareOfVoiceSummaryTable = ({ shareSummary }: Props) => {
  const entries = Object.entries(shareSummary)

  return (
    <table className='border-secondary w-full border-collapse border-l'>
      <thead>
        <TableRow head>
          <TableHeadItem type='thin'>
            <Text size={12} color={TextColor.SECONDARY}>
              ブランド
            </Text>
          </TableHeadItem>
          {METRICS.map((m) => (
            <TableHeadItem key={m.key} type='thin'>
              <Text size={12} color={TextColor.SECONDARY}>
                {m.label}
              </Text>
            </TableHeadItem>
          ))}
        </TableRow>
      </thead>
      <tbody>
        {entries.map(([brand, data], i) => (
          <TableRow key={brand}>
            <TableRowItem>
              <ItemAlign gapX={8} align='center' nowrap>
                <div
                  className='h-3 w-3 shrink-0 rounded-sm'
                  style={{ background: PIE_CHART_COLORS[i % PIE_CHART_COLORS.length] }}
                />
                <Text size={14}>{brand}</Text>
              </ItemAlign>
            </TableRowItem>
            {METRICS.map((m) => (
              <TableRowItem key={m.key}>
                <Text size={14}>
                  {data[m.key]}
                  {m.suffix ?? ''}
                </Text>
              </TableRowItem>
            ))}
          </TableRow>
        ))}
      </tbody>
    </table>
  )
}

export default ShareOfVoiceSummaryTable
